import styled from 'styled-components'
import { BLUE, GRAY } from '../../../styles/colors.style'
import { breakpoints } from './../../../constants'

const setColors = ({ isActive }) => (isActive ? `${BLUE}` : `${GRAY}`)

export const StyledRadioButton = styled.div`
	align-items: center;
	box-shadow: ${({ isActive }) =>
		isActive ? '0px 4px 10px rgba(0,0,0,0.15)' : null};
	color: ${setColors};
	display: flex;
	font-size: 16px;
	justify-content: center;
	padding: 15px;
	${({ noBorder, isActive }) =>
		noBorder ? '' : `border: 1px solid ${isActive ? `${BLUE}` : `${GRAY}`};`}
	text-align: center;
	z-index: ${({ isActive }) => (isActive ? '1' : 'unset')};

	&:hover {
		cursor: ${({id}) => id === 'bankslip-ticketsale-false' ? 'auto' : 'pointer'};
	}

	&.livelo {
		padding: 5px;
		
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			padding: 8px 15px;
		}
	}
`
